import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FaqService } from './faq.service';
import { JwtHelperService } from '@auth0/angular-jwt';
var FaqComponent = /** @class */ (function () {
    function FaqComponent(faqService, router) {
        this.faqService = faqService;
        this.router = router;
        this.jwtHelperService = new JwtHelperService();
    }
    FaqComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.token = localStorage.getItem('tk');
        this.user = this.token && this.jwtHelperService.decodeToken(this.token);
        if (!this.user) {
            this.router.navigate(['forbidden']);
        }
        this.faqService.getQuestions().subscribe(function (response) {
            var data = response.data;
            _this.questions = data.grupos[0].preguntas;
        });
    };
    return FaqComponent;
}());
export { FaqComponent };
